import { render, staticRenderFns } from "./LicensePage.vue?vue&type=template&id=488b55db&scoped=true&"
import script from "./LicensePage.vue?vue&type=script&lang=js&"
export * from "./LicensePage.vue?vue&type=script&lang=js&"
import style0 from "./LicensePage.vue?vue&type=style&index=0&id=488b55db&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488b55db",
  null
  
)

export default component.exports